import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {RoadKill} from "../../RoadKill";
import {TimelineLite} from "gsap";
import {DIRECTION, SYMBOL_NAME} from "../../component/enums/RoadKillEnums";
import {BelowStakeWinRestriction} from "../../server/BelowStakeWinRestriction";
import {ISpecialSymData} from "../../server/RoadKillData";
import {SimplePresentation, SimplePresentationRunner} from "../../../core/winpresentation/SimplePresentationRunner";
import {RoadKillFreespinIntroRunner} from "../../presentationRunners/RoadKillFreespinIntroRunner";
import {RoadKillUtils} from "../../utils/RoadKillUtils";
import {RoadKillGameMode} from "../../server/RoadKillGameMode";
import {SimpleReelModel} from "../../../core/reel/simplereel/SimpleReelModel";

export class RoadKillIdleRespinPresentation implements FlowStatePresentation {
    private readonly _presentations: SimplePresentation[];

    constructor() {
        this._presentations = [new RoadKillFreespinIntroRunner()];
    }

    public start(flowStateController: FlowStateController): void {
        SimplePresentationRunner.run(this._presentations, () => this.complete(flowStateController), (callback?: Function) => flowStateController.setSkipCallback(callback))
    }

    public complete(flowStateController: FlowStateController) {
        const tl: TimelineLite = new TimelineLite();
        if (RoadKill.model.isRestore) {
            tl.add(() => {
                this.handleRestore();
            });
            RoadKill.keypadPlugin.setWin(RoadKill.model.initData.accumulatedRoundWin, true, BelowStakeWinRestriction.isWinBelowStake());
        } else {
            if (RoadKill.keypadPlugin.showing) {
                RoadKill.keypadPlugin.hide(0.1);
            }
        }
        tl.add(() => {
            RoadKill.movingCar.setCarDirectionAndPos(DIRECTION.RIGHT, 1);
            RoadKill.movingCar.playCarTease();
            if (RoadKill.model.data.totalAnimalHitsSFS === 20 && RoadKill.model.nextMode === RoadKillGameMode.SUPER_FREESPIN) {
                SimpleReelModel.SPEED = 3;
                // RoadKill.reelView.addExcitement(0);
                // RoadKill.reelView.addExcitement(4);
            } else {
                SimpleReelModel.SPEED = 1;
            }
            RoadKill.apiPlugin.betHandler.zeroBet();
            flowStateController.finish();
        });
    }

    private handleRestore(): void {
        const tl: TimelineLite = new TimelineLite();
        RoadKill.model.initData.specialSymbolList.forEach((specialSymData: ISpecialSymData, index: number) => {
            const specialSymDataCopy: ISpecialSymData = Object.assign({}, specialSymData);
            specialSymDataCopy.coordFrom = specialSymDataCopy.coordTo || specialSymDataCopy.coordFrom;
            tl.add(RoadKill.jumpingWildView.onLand(specialSymDataCopy, true));
            tl.add(RoadKill.topAnimalController.getJWPopInAnim(RoadKillUtils.getJWType(specialSymData.symName), specialSymData.upgraded));
            if (RoadKill.model.data.nextMode !== RoadKillGameMode.SUPER_FREESPIN) {
                tl.add(RoadKill.topAnimalController.updateTopAnimalHits(specialSymData.symName as SYMBOL_NAME, specialSymData.getHitCount, true));
            }
        });
        if (RoadKill.model.data.nextMode === RoadKillGameMode.SUPER_FREESPIN) {
            if (RoadKill.model.data.totalAnimalHitsSFS <= 0) {
                tl.add(RoadKill.topAnimalController.onSuperFsTriggered());
            } else if (RoadKill.model.data.totalAnimalHitsSFS != 20) {
                tl.add(RoadKill.topAnimalController.setTotalHits(RoadKill.model.data.totalAnimalHitsSFS));
            }

        }
        tl.add([RoadKill.backgroundElements.updateMultiplier(RoadKill.model.data.persistentMultiplier),
            RoadKill.lifeView.update(RoadKill.model.data.heartList)
        ]);
        RoadKill.reelView.handleWildOverlayRestore();
        RoadKill.reelView.handleSplitOverlayRestore();
        tl.timeScale(100);
    }


}